<template>
  <div>
		<!-- =========== End of Loader ============ -->

		<main class="main ">
			<!-- =========== Start of Body ============ -->

			<!-- end of top right mini svg shape -->

			<div class="container">
				<div class="row">
                    
					<div class="col-12 mx-auto   mb-4 mb-lg-5">
                        
						<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mx-auto">
							<div
								class="form--v10 px-3 py-4 px-md-5 py-md-6 rounded--11 bg-color--light--1"
							>

                            <h4 class="mb-3 font-weight-bold">{{$t("sidebar.identityInfo")}}</h4>
							<hr />
								<div class="container">
                                    
									<div class="row justify-content-between">
										<div class="col-md-5">
											<div>
												<label class="form__label font-size--15 font-w--500">{{
													$t("register.name") + "  :  "
												}}</label>
												<label
													class="form__label text-uppercase font-size--15 font-w--400"
													>{{ "  " + name }}</label
												>
											</div>
										</div>

										<div class="col-md-5">
											<div class="form-group">
												<label
													class="form__label text-uppercase font-size--15 font-w--500"
													>{{ $t("register.lastName") + "  :  " }}</label
												>
												<label
													class="form__label text-uppercase font-size--15 font-w--400"
													>{{ lastName }}</label
												>
											</div>
										</div>
									</div>
									<div class="row justify-content-between">
										<div class="col-md-5">
											<div class="form-group">
												<label
													class="form__label text-uppercase font-size--15 font-w--500"
													>{{ $t("register.melliCode") + "  :  " }}</label
												>
												<label
													class="form__label text-uppercase font-size--15 font-w--400"
													>{{ melliCode }}</label
												>
											</div>
										</div>
										
										<div class="col-md-5">
											<div class="form-group">
												<label
													class="form__label text-uppercase font-size--15 font-w--500"
													>{{ $t("register.fatherName") + "  :  " }}</label
												>
												<label
													class="form__label text-uppercase font-size--15 font-w--400"
													>{{ fatherName }}</label
												>
											</div>
											
										</div>
										
									</div>
									

									<!-------------- register user Informations ------------->

									<div class="row justify-content-between">
										<div class="col-md-5">
											<div class="form-group">
												<label class="form__label  font-size--15 font-w--500">{{
													$t("register.mobileNumber") + "  :  "
												}}</label>
												<label
													class="form__label text-uppercase font-size--15 font-w--400"
													>{{ mobile }}</label
												>
											</div>
										</div>
										<div class="col-md-5">
											<div class="form-group">
												<label
													class="form__label text-uppercase font-size--15 font-w--500"
													>{{ $t("register.phone") + "  :  " }}</label
												>
												<label
													class="form__label text-uppercase font-size--15 font-w--400"
													>{{ phone }}</label
												>
											</div>
												</div>
												<div class="col-md-5">
											
											<div class="form-group ">
												<label
													class="form__label text-uppercase font-size--15 font-w--500"
													>{{ $t("register.phoneDes") + "  :  " }}</label
												>
												<label
													class="form__label text-uppercase font-size--15 font-w--400"
													>{{ phoneNumberDescription }}</label
												>
										
											</div>
										</div>
										<div class="col-md-5">
											
											<div class="form-group ">
												<label
													class="form__label text-uppercase font-size--15 font-w--500"
													>{{ $t("register.birthday") + "  :  " }}</label
												>
												<label
													class="form__label text-uppercase font-size--15 font-w--400"
													>{{ birthDate }}</label
												>
										
											</div>
										</div>
										<div class="col-md-5">
											
											<div class="form-group ">
												<label
													class="form__label text-uppercase font-size--15 font-w--500"
													>{{ $t("register.education") + "  :  " }}</label
												>
												<label v-if="education==0"
													class="form__label text-uppercase font-size--15 font-w--400"
													>{{ $t("register.educations.illiterate")}}</label>
												<label v-if="education==1"
													class="form__label text-uppercase font-size--15 font-w--400"
													>{{ $t("register.educations.elementary")}}</label>
												<label v-if="education==2"
													class="form__label text-uppercase font-size--15 font-w--400"
													>{{ $t("register.educations.sycle")}}</label>
												<label v-if="education==3"
													class="form__label text-uppercase font-size--15 font-w--400"
													>{{ $t("register.educations.diploma")}}</label>
												<label v-if="education==4"
													class="form__label text-uppercase font-size--15 font-w--400"
													>{{ $t("register.educations.skilled")}}</label>
												<label v-if="education==5"
												class="form__label text-uppercase font-size--15 font-w--400"
												>{{ $t("register.educations.bachelor")}}</label>
												<label v-if="education==6"
													class="form__label text-uppercase font-size--15 font-w--400"
													>{{ $t("register.educations.master")}}</label>
												<label v-if="education==7"
													class="form__label text-uppercase font-size--15 font-w--400"
													>{{ $t("register.educations.phd")}}</label>
												<label v-if="education==8"
												class="form__label text-uppercase font-size--15 font-w--400"
												>{{ $t("register.educations.medical")}}</label>
												<label v-if="education==9"
												class="form__label text-uppercase font-size--15 font-w--400"
												>{{ $t("register.educations.clergy")}}</label>
										
											</div>
										</div>
										<div class="col-md-5">
											
											<div class="form-group ">
												<label
													class="form__label text-uppercase font-size--15 font-w--500"
													>{{ $t("register.gender") + "  :  " }}</label
												>
												<label v-if="gender=='m'"
													class="form__label text-uppercase font-size--15 font-w--400"
													>{{ $t("register.male") }}</label
												>
												<label v-if="gender=='f'"
													class="form__label text-uppercase font-size--15 font-w--400"
													>{{ $t("register.female") }}</label
												>
										
											</div>
										</div>
										<div class="col-md-5">
											
											<div class="form-group ">
												<label
													class="form__label text-uppercase font-size--15 font-w--500"
													>{{ $t("register.maritalStatus") + "  :  " }}</label
												>
												<label v-if="martialStatus==0"
													class="form__label text-uppercase font-size--15 font-w--400"
													>{{ $t("register.single") }}</label
												>
												<label v-if="martialStatus==1"
													class="form__label text-uppercase font-size--15 font-w--400"
													>{{ $t("register.married") }}</label
												>
												<label v-if="martialStatus==2"
													class="form__label text-uppercase font-size--15 font-w--400"
													>{{ $t("register.headOfHousehold") }}</label
												>
										
											</div>
										</div>
										
									</div>
								</div>
								<!-------------------------------customer DAta -------------------->
								

								
								
								

								<!-- end of form -->
							</div>
							<!-- end of from area -->
						</div>
						<!-- end of col -->
					</div>
					<!-- end of row -->

					<!-- end of container -->
				</div>
			</div>
			<!-- =========== End of Body ============ -->
		</main>
	</div>
</template>

<script>
import * as moment from 'jalali-moment';
export default {
    mounted()
    {
		let load = this.$loading.show();
		
        this.$store.dispatch("getCustomer").then(response=> {
			this.name = response.body.first_name;
			this.lastName = response.body.last_name;
			this.melliCode = response.body.melli_code;
			this.fatherName = response.body.father_name;
			this.mobile = response.body.mobile_number;
			this.phone = response.body.phone_number;	
			this.phoneNumberDescription = response.body.phone_number_description
			if(response.body.birth_date)
			{
				this.birthDate = this.convertDate(response.body.birth_date) 
			}
			
			this.gender = response.body.gender
			this.martialStatus = response.body.marital_status
			this.education=response.body.education
			
			load.hide()      
	})

        

       
    }
    ,
    data()
    {
        return {
            
            name:'',
            lastName:'',
            melliCode:'',
            fatherName:'',
            mobile:'',
            phone:'',
			phoneNumberDescription:'',
			birthDate:'',
			gender:'',
			martialStatus:'',
			education:'',
			

        }
    },
	methods:
	{
		convertDate(date)
		{
			
			
			var newDate=date.replace(/-/g, '/')
			return moment(newDate, 'YYYY/MM/DD').locale('fa').format('YYYY/MM/DD')
			
		}
	}
}
</script>

<style>

</style>